<template>
    <v-layout wrap row class="m-block-form-buttons" :justify-space-between="showCancelButton"
              :justify-end="!showCancelButton">
        <v-flex shrink class="m-block-form-buttons__container" :class="{'pr-0': breakpoints.isLessThanMobile}"
                v-if="showCancelButton">
            <e-button-secondary :class="classes" :sel-id="selId" @click="$emit('cancel')">
                {{ cancel }}
            </e-button-secondary>
        </v-flex>
        <v-flex shrink :class="{'pl-0': breakpoints.isLessThanMobile}">
            <div class="tooltip-wrap">
                <e-button-primary :disabled="(status == 'submitDisabled')" :loading="isLoading" :sel-id="selId"
                                  :class="classes"
                                  @click="$emit('submit')">
                    {{ submit }}
                </e-button-primary>
                <span class="tooltip" v-if="(status == 'submitDisabled')">
                    {{$t('pages.dashboard.account.submit-disabled-tooltip')}}
                </span>
            </div>
        </v-flex>
    </v-layout>
</template>

<script>
    let name = 'm-block-form-buttons';

    export default {
        name: name,
        props: {
            isLoading: {
                type: Boolean,
                default: false
            },
            text: {
                type: Object
            },
            showCancelButton: {
                type: Boolean,
                default: true
            },
            context: {
                type: String,
                default: 'default',
                validator: function (v) {
                    return ['create', 'update', 'default'].indexOf(v) !== -1
                }
            },
            selId: {
                type: String,
                required: false
            },
            status: {
                type: String,
                required: false
            }
        },
        computed: {
            cancel() {
                if (this.context === 'default') {
                    return this.text ? this.text.cancel : this.$t(`modules.blocks.${name}.cancel`)
                } else {
                    return this.$t(`modules.blocks.${name}.back`)
                }
            },
            submit() {
                if (this.context === 'default') {
                    return this.text ? this.text.submit : this.$t(`modules.blocks.${name}.submit`)
                } else {
                    return this.$t(`modules.blocks.${name}.${this.context}`)
                }
            },
            classes() {
                return ['ma-0']
            }
        }
    }
</script>

<style lang="scss" scoped>
    .m-block-form-buttons {
        @media (min-width: $md) {
            margin: -10px !important;
        }

        .tooltip-wrap {
            position: relative;

            .tooltip {
                position: absolute;
                z-index: 1;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                background: rgba(0, 0, 0, .65);
                color: var(--v-white-base);
                text-align: center;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 4px;
                cursor: not-allowed;
                opacity: 0;
                &:hover {
                    opacity: 1;
                }
            }
        }

        .v-btn.e-button.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
            background-color: var(--v-secondary-base) !important;
            box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
            0px 2px 2px 0px rgba(0, 0, 0, 0.14),
            0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
            color: rgba(54, 54, 54, .5) !important;
        }
    }


</style>
